import { createSlice } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  startDate: subDays(new Date(), 30),
  endDate: new Date(),
  excelSendModal: false,
  storeId: "",
  planId: "",
  /**
   * Empty means every status, which is the point: a plan is debited when the order is placed
   * rather than when the counter marks it delivered, so the orders still being prepared have
   * already drawn the customer's balance down and belong on the screen by default.
   */
  status: "",
  totalCount: "",
};

const subscriptionOrdersSlice = createSlice({
  name: "subscriptionOrders",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = subscriptionOrdersSlice.actions;
export default subscriptionOrdersSlice.reducer;
